module.exports = __webpack_public_path__ + "img/logo.76c531b4.png";